import { SEND_CONTACT_FAILURE, SEND_CONTACT_REQUEST, SEND_CONTACT_SUCCESS } from './actions';

const initialState = {
  loading: false,
  error: null,
  message: '',
};

export const contactReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEND_CONTACT_REQUEST:
      return {
        loading: true,
        error: null,
      };

    case SEND_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };
    case SEND_CONTACT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
